/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListHospitalsQueryResponse,
  ListHospitalsQueryParams,
} from '../types/ListHospitals'

function getListHospitalsUrl() {
  const res = { method: 'GET', url: `/api/v1/hospital/` as const }
  return res
}

/**
 * @summary List hospitals
 * {@link /api/v1/hospital/}
 */
export async function listHospitals(
  params?: ListHospitalsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListHospitalsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListHospitalsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
